import type {
  StringRangeType,
  DecimalRangeType,
} from '@libs/trip-planner-interfaces';

export function safelyDeserializeFilter<T>(
  value: string | undefined,
  deserializer: (value: string) => T
): T | undefined {
  if (!value) {
    return undefined;
  }

  return deserializer(value);
}

const RANGE_FILTER_SEPARATOR = '-';

export const rangeTimeSerializer = {
  serialize: function (timeRange?: StringRangeType): string {
    const fromTime = timeRange?.from ?? '';
    const toTime = timeRange?.to
      ? `${RANGE_FILTER_SEPARATOR}${timeRange.to}`
      : '';
    const serializedTime = fromTime.concat(toTime);
    return serializedTime;
  },
  deserialize: function (value: string): StringRangeType {
    const [from, to] = value.split(RANGE_FILTER_SEPARATOR);
    return {
      from: from || undefined,
      to,
    };
  },
};

export const rangePriceSerializer = {
  serialize: function (priceRange?: DecimalRangeType): string {
    const fromTime = priceRange?.from?.toString() ?? '';
    const toTime = priceRange?.to
      ? `${RANGE_FILTER_SEPARATOR}${priceRange.to}`
      : '';
    const serializedPrice = fromTime.concat(toTime);
    return serializedPrice;
  },
  deserialize: function (value: string): DecimalRangeType {
    const [from, to] = value.split(RANGE_FILTER_SEPARATOR);
    return {
      from: Number(from) || undefined,
      to: Number(to) || undefined,
    };
  },
};
